module.exports = __webpack_public_path__ + "img/25.c9b7912d.jpg";